<template>

  <Head>
    <title>{{ title }}</title>
    <meta name="description" :content="description" />
    <meta name="keywords" :content="keywords" />
  </Head>

  <!-- Center Screen Notifier -->
  <!-- <div v-if="showNotice" class="notice-overlay" @click="dismissNotice">
    <div class="notice-box" @click.stop>
      <button class="close-btn" @click="dismissNotice" aria-label="Close">&times;</button>
      <img style="width:50%; height:50%;" src="../assets/img/news/christmas.jpg">
    </div>
  </div> -->

  <div class="home-container">
    <SplashContainer :title="splashTitle" :subtitle="splashSubtitle" :splashImageUrl="splashImage">

      <a href="https://app.orderopia.com/fradley-fryer/order" class="mt-4 btn btn-primary" style="font-size:1.1rem;">
        <span>Order Online</span>
        <img alt="arrow right" class="ms-2" style="height:20px;" src="../assets/img/arrow-right.webp">
      </a>

    </SplashContainer>

    <!-- Rest of your page content... -->

  </div>
</template>

<script>
import SplashContainer from '../components/SplashContainer.vue'
import splash from "../assets/img/splash.webp";
import { Head } from '@vueuse/head';

export default {
  components: {
    SplashContainer,
    Head
  },
  data() {
    return {
      title: "Fradley Fryer | Fish & Chips",
      description: "Fresh food from Fradley Fryer. Order now. The food you really want is just one click away. Order fish and chips online.",
      keywords: "fradleyfryer,fradley fryer, fradley fryer fish and chips, fish and chips fradley fryer, fish fradley, chips fradley, chippy fradley",
      splashImage: splash,
      splashSubtitle: "Fradley Fryer",
      splashTitle: "Fish & Chips",
      showNotice: false
    }
  },
  methods: {
    dismissNotice() {
      this.showNotice = false;
      sessionStorage.setItem('pizzaNoticeDismissed', 'true');
    }
  },
  mounted() {
    // Show only if not dismissed this session
    const dismissed = sessionStorage.getItem('pizzaNoticeDismissed');
    if (!dismissed) {
      this.showNotice = true;
    }

    // eslint-disable-next-line
    initOrderopia();
  }
}
</script>

<style scoped>
/* Overlay background */
.notice-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
  cursor: pointer;
}

/* Notice box */
.notice-box {
  background-color: #fff3cd;
  color: #664d03;
  border: 1px solid #ffe69c;
  border-radius: 10px;
  padding: 1.5rem 2rem;
  max-width: 500px;
  text-align: center;
  font-weight: 600;
  position: relative;
  cursor: default;
  box-shadow: 0 4px 20px rgba(0,0,0,0.2);
}

/* Close button */
.close-btn {
  position: absolute;
  top: 0.5rem;
  right: 0.75rem;
  background: none;
  border: none;
  font-size: 1.5rem;
  color: #664d03;
  cursor: pointer;
}

.close-btn:hover {
  color: #000;
}
</style>
